import React from 'react'
import { Box, CircularProgress } from '@mui/material'

export const FilterCircularProgress = () => {
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
                justifyContent: 'center',
                flexGrow: 1,
                textAlign: 'center',
                color: 'text.secondary',
                px: 2
            }}
        >
            <CircularProgress />
        </Box>
    )
}
